// Main entry point for the PepTalk Widget
export { Widget } from './widget';
export * from './types';
export * from './utils';
export * from './components';

// Import styles if needed
import './styles.scss';

// Global widget initialization function for easy usage
declare global {
  interface Window {
    Peptalk: typeof import('./widget').Widget;
  }
}

// Expose Widget to global scope for browser usage
import { Widget } from './widget';

if (typeof window !== 'undefined') {
  // Add version and debug info to the global object
  const PeptalkGlobal = Object.assign(Widget, {
    version: process.env.WIDGET_VERSION || 'unknown',
    debug: () => {
      console.log('PepTalk Widget Debug Info:');
      console.log('- Version:', process.env.WIDGET_VERSION || 'unknown');
      console.log('- Build Date:', process.env.BUILD_TIMESTAMP || 'unknown');
      console.log('- Widget instance:', Widget.getInstance());
      console.log(
        '- Container:',
        document.querySelector('.peptalk-widget-container')
      );
      console.log(
        '- Button:',
        document.querySelector('.peptalk-widget-button')
      );
      console.log(
        '- Theme styles:',
        document.querySelector('#peptalk-theme-styles')
      );

      // Log CSS variables if container exists
      const container = document.querySelector('.peptalk-widget-container');
      if (container) {
        const computedStyle = getComputedStyle(container);
        console.log(
          '- Primary color:',
          computedStyle.getPropertyValue('--peptalk-color-primary')
        );
        console.log('- Container position:', computedStyle.position);
        console.log('- Container z-index:', computedStyle.zIndex);
      }
    },
  });

  window.Peptalk = PeptalkGlobal;
}

// Export Widget as default for webpack UMD build
export { Widget as default };
